import config from '../utils/config';
import Vue from 'vue'
import {
  Notification,
} from 'element-ui'
import { resolve } from 'path';
import { reject } from 'q';
this.$notify = Notification
/**
 * 图像处理
 * @param {Object} url 图像地址
 * @param {Object} h  高度
 * @param {Object} w  宽度
 * @param {Object} modenum 1.自适应 2.固定宽高短边缩放 3.固定宽高居中裁剪 4.强制宽高
 * @param {Object} type  使用类型
 * @param {Object} format  图形格式
 * @param {Object} resize  resize
 * @param {Object} multiple  放大倍数
 *
 * $wanlshop.oss(url, 120, 0, 2, 'transparent', 'png')
 */
const oss = (url) => {
  let image = '';
  //当地址不存在
  if (url) {
    if ((/^data:image\//.test(url))) {
      image = url;
    } else if ((/^(http|https):\/\/.+/.test(url))) {
      image = url;
    } else {
      image = config.imgUrl + url;
    }
  } else {

  }
  return image;
}


const addFavorite = () => {
  var url = window.location;
  var title = document.title;
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("360se") > -1) {
    alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
  } else if (ua.indexOf("msie 8") > -1) {
    window.external.AddToFavoritesBar(url, title); //IE8
  } else if (document.all) {
    try {
      window.external.addFavorite(url, title);
    } catch (e) {
      alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
    }
  } else if (window.sidebar) {
    window.sidebar.addPanel(title, url, "");
  } else {
    alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
  }
}


/**
 * 时间格式化
 *
 * @param String timestamp 时间戳
 * @param String fmt 返回的时间格式
 * yyyy:mm:dd|yyyy:mm|yyyy年mm月dd日|yyyy年mm月dd日 hh时MM分等,可自定义组合
 */
const timeFormat = (timestamp = null, fmt = 'yyyy-mm-dd') => {
  // 其他更多是格式化有如下:
  // yyyy:mm:dd|yyyy:mm|yyyy年mm月dd日|yyyy年mm月dd日 hh时MM分等,可自定义组合
  timestamp = parseInt(timestamp);
  // 如果为null,则格式化当前时间
  if (!timestamp) timestamp = Number(new Date());
  // 判断用户输入的时间戳是秒还是毫秒,一般前端js获取的时间戳是毫秒(13位),后端传过来的为秒(10位)
  if (timestamp.toString().length == 10) timestamp *= 1000;
  let date = new Date(timestamp);
  let ret;
  let opt = {
    "y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "h+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "s+": date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    };
  };
  return fmt;
}

const testPhone = (resPhone) => {
  let phone = new Promise((resolve, reject) => {
    const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/g;
    if (resPhone.trim() == "" || resPhone == undefined || resPhone == null || resPhone.length == 0) {
      this.$notify.error({
        title: '手机号不能为空',
        message: '手机号不能为空',
      });
      resolve(false);
    } else if (!reg.test(resPhone)) {

      resolve(true);
    } else {
      resolve(true);
    }
  });
  return phone;
};
// 通过token判断是否登录
const IsToken = () => {
  let token = new Promise((resolve, reject) => {
    if (localStorage.getItem('token')) {
      resolve(true);
    } else {
      resolve(false);
    }
  })
  return token
};
// 处理手机号
const judeg = (e) => {
  let cal = e.replace(/[^0-9]/ig, "")
  if (cal.length == 11) {
    var phNum = cal
    return phNum.substr(0, 3) + "********" + phNum.substr(11);
  } else {
    return e;
  }
};


const open1 = (text) => {
  this.$notify.info({
    title: '消息',
    message: text,
  });
}

const open2 = (text) => {
  this.$notify({
    title: '成功',
    message: text,
    type: 'warning'
  });
}

const open3 = (text) => {
  this.$notify.erro({
    title: '成功',
    message: text,
  });
}

const open_blank = (url) => {
  const baseURL = "http://localhost:8080/#" 
  if (url) {
    if ((/^(http|https):\/\/.+/.test(url))) {
      window.open(url,'_blank')
    } else {
      window.open(baseURL + url,'_blank')
    }
  } else {
    window.open("https://www.aghgzx.com/",'_blank')
    // window.open("https://gyl.kswlll.com/",'_blank')
    // window.open("https://supply.aghgzx.com",'_blank')
  }

}


export default {
  open1,
  open2,
  open3,
  oss,
  addFavorite,
  timeFormat,
  testPhone,
  IsToken, 
  judeg,
  open_blank
}



// WEBPACK FOOTER //
// ./src/utils/utils.js